import { render, staticRenderFns } from "./EstruturaRateioWbc.vue?vue&type=template&id=4220e082&scoped=true&"
import script from "./EstruturaRateioWbc.vue?vue&type=script&lang=js&"
export * from "./EstruturaRateioWbc.vue?vue&type=script&lang=js&"
import style0 from "./EstruturaRateioWbc.vue?vue&type=style&index=0&id=4220e082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4220e082",
  null
  
)

export default component.exports